// extracted by mini-css-extract-plugin
module.exports = {"preview":"teaser-module--preview--1SQmG","videoMask":"teaser-module--videoMask--394M2"};